import { useTranslations } from "@/hooks/use-translations";
import { useBankIdStore } from "@/stores/bank-id/bank-id-store";
import type { BankIdStore } from "@/stores/bank-id/bank-id-store.types";

export function Countdown() {
  const { __, __xw } = useTranslations();

  const secondsLeft = useBankIdStore((state: BankIdStore) => state.secondsLeft);

  const minutesLeft = Math.round(secondsLeft / 60);

  return (
    <div aria-live="polite" className={"mt-2 text-center text-sm"}>
      {secondsLeft >= 60 && (
        <span>
          {__xw("bank_id.countdown.minutes_left", minutesLeft, {
            minutes: minutesLeft.toString(),
          })}
        </span>
      )}
      {secondsLeft < 60 && (
        <span>{__("bank_id.countdown.less_one_minute_left")}...</span>
      )}
    </div>
  );
}
